<!-- Banners above the view: no data, quote errors, data warnings. -->
<script lang="ts">
  import { app, need } from "../lib/state.svelte";
  const m = $derived(need(app.model));
  const d = $derived(need(app.data));
  const fxMissing = $derived(m.warnings.filter((w) => w.startsWith("Brak kursów walut")));
  // skip fetch errors if the symbol has quotes anyway (e.g. from data/prices/manual.csv)
  const hasPx = (e: string) => { const sym = String(e).split(":")[0]; const src = m.priceSource[sym]; return !!src && src !== "fallback" && src !== "none"; };
  const other = $derived([...(app.market?.errors || []).filter((e) => !hasPx(e)), ...m.warnings.filter((w) => !w.startsWith("Brak kursów walut")), ...(d.errors || [])]);
  const fallback = $derived(Object.entries(m.priceSource).filter(([s, v]) => v === "fallback" && m.txs.some((t) => t.symbol === s)).map(([s]) => s));
  const noTx = $derived(!d.transactions.length);
  const any = $derived(noTx || !!app.marketError || !!app.market?.refreshing || fxMissing.length > 0 || fallback.length > 0 || other.length > 0);
  // consecutive messages separated by <br>
  const items = $derived([noTx && "notx", app.marketError && "mkt", app.market?.refreshing && "refresh", ...fxMissing.map((_, i) => "fx" + i), fallback.length && "fallback"].filter(Boolean) as string[]);
</script>

<div id="banner">
  {#if any}
    <div class="notice">
      {#each items as it, i (it)}
        {#if i}<br />{/if}
        {#if it === "notx"}Brak transakcji. Zaimportuj pliki brokerów w zakładce <a href="#/import">Import i dane</a>.
        {:else if it === "mkt"}Nie udało się pobrać notowań: {app.marketError}
        {:else if it === "refresh"}Pobieram notowania i kursy walut w tle — wykresy odświeżą się same.
        {:else if it === "fallback"}<b>Brak notowań rynkowych dla: {fallback.join(", ")}.</b> Wartości w przeszłości są przybliżone: do czasu kolejnej transakcji lub raportu brokera przyjmowana jest ostatnia znana cena, stąd skoki na wykresach w dniach raportów. Szczegóły błędów poniżej; kliknij ↻, aby spróbować ponownie, albo popraw symbol w <a href="#/import">Import i dane → Instrumenty</a>.
        {:else}{fxMissing[+it.slice(2)]}{/if}
      {/each}
      {#if other.length}<details><summary>Uwagi dotyczące danych ({other.length})</summary><ul>{#each other as x, i (i)}<li>{x}</li>{/each}</ul></details>{/if}
    </div>
  {/if}
</div>
